// src/common/SessionTimeoutModal.jsx
import React, { useState, useEffect } from 'react';
import { LogOut, X } from 'lucide-react';
import unifiedAuthManager from '../services/unifiedAuthManager';

let showSessionTimeoutModal = null;
let hideSessionTimeoutModal = null;
  const userRoles = unifiedAuthManager.getUserRoles() || [];
  const isCandidate = userRoles.some(role => 
    role.toLowerCase().includes('role_candidateuser')
  );

// Global functions to control modal
export const triggerSessionTimeout = () => {
  if (showSessionTimeoutModal) {
    showSessionTimeoutModal();
  }
};

export const hideSessionTimeout = () => {
  if (hideSessionTimeoutModal) {
    hideSessionTimeoutModal();
  }
};

const SessionTimeoutModal = () => {
  const [isVisible, setIsVisible] = useState(false);
  const [isLoggingOut, setIsLoggingOut] = useState(false);

  // Expose functions globally
  useEffect(() => {
    showSessionTimeoutModal = () => setIsVisible(true);
    hideSessionTimeoutModal = () => setIsVisible(false);

    // Cleanup on unmount
    return () => {
      showSessionTimeoutModal = null;
      hideSessionTimeoutModal = null;
    };
  }, []);

  const handleLogout = async () => {
    setIsLoggingOut(true);
    try {
      // await AuthService.logout();
      unifiedAuthManager.clearAll();
      if(isCandidate){
        window.location.href = '/resume-login';
      }else{
        window.location.href = '/login';  
      }
    } catch (error) {
      console.error('Logout failed:', error);
      // Force redirect even if logout fails
      window.location.href = '/login';
    }
  };

  const handleClose = () => {
    if (!isLoggingOut) {
      setIsVisible(false);
    }
  };

  if (!isVisible) return null;

  return (
    <>
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black bg-opacity-50 z-[9999]"
        onClick={handleClose}
      />
      
      {/* Modal */}
      <div className="fixed inset-0 flex items-center justify-center z-[10000] p-4">
        <div className="bg-white rounded-lg shadow-xl max-w-md w-full mx-4">
          {/* Header */}
          <div className="flex items-center justify-between p-3 border-b border-gray-200">
            <h3 className="text-lg font-semibold text-gray-900">Session Expired</h3>
            {/* {!isLoggingOut && (
              <button
                onClick={handleClose}
                className="text-gray-400 hover:text-gray-600 transition-colors"
              >
                <X className="w-5 h-5" />
              </button>
            )} */}
          </div>

          {/* Content */}
          <div className="p-6">
            <div className="text-center">
              <div className="w-16 h-16 mx-auto mb-4 mph-light rounded-full flex items-center justify-center">
                <LogOut className="w-8 h-8 mph-primary" />
              </div>
              
              <p className="text-gray-600 mb-6">
                Your session has expired due to inactivity. Please log in again to continue.
              </p>

              <button
                onClick={handleLogout}
                disabled={isLoggingOut}
                className={`w-full px-4 py-2 text-sm font-medium text-white bg-gradient rounded-md transition-colors flex items-center justify-center space-x-2 ${
                  isLoggingOut ? 'opacity-50 cursor-not-allowed' : 'hover:shadow-lg'
                }`}
              >
                {isLoggingOut ? (
                  <>
                    <div className="w-4 h-4 border-2 border-white border-t-transparent rounded-full animate-spin"></div>
                    <span>Logging out...</span>
                  </>
                ) : (
                  <>
                    <LogOut className="w-4 h-4" />
                    <span>Login Again</span>
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default SessionTimeoutModal;